import styled from "styled-components";

export const ModalValidationDescription = styled.p`
  margin: 0 0 10px 0;
`

export const FormContainer = styled.div`
  display: grid;
  gap: 15px;
`
